import React from 'react'
import { Box } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { IMotorCarrier } from 'apps/fleet-planner/types'
import { Select, TextField, Switch, ITextFieldProps, ISelectProps } from 'transfix-ui'

interface IEquipmentListingFilterProps {
  carriers: IMotorCarrier[]
  onCarrierChange: (carrierId: number) => void
  onInactiveToggleChange: () => void
  onSearchChange: (search: string) => void
  selectedCarrierId?: number
  showInactiveAndUnassigned?: boolean
  trailerSearchInput?: string
}

const useStyles = makeStyles(() => ({
  carrierSelect: {
    '& .MuiSelect-selectMenu': {
      height: 24,
    },
  },
}))

const EquipmentListingFilter = ({
  carriers,
  onCarrierChange,
  onInactiveToggleChange,
  onSearchChange,
  selectedCarrierId,
  showInactiveAndUnassigned = false,
  trailerSearchInput,
}: IEquipmentListingFilterProps) => {
  const classes = useStyles()
  const carrierOptions = carriers.map(item => ({
    value: item.id,
    label: item.name,
  }))

  const carrierChangeHandler: ISelectProps['onChange'] = event => {
    onCarrierChange(event.target.value as number)
  }

  const searchChangeHandler: ITextFieldProps['onChange'] = event => {
    onSearchChange(event.target.value as string)
  }

  return (
    <Box display='flex' flexDirection='row' alignItems='center'>
      {carrierOptions.length > 1 && (
        <Box className={classes.carrierSelect} width={240} marginRight={2}>
          <Select
            options={carrierOptions}
            value={selectedCarrierId}
            onChange={carrierChangeHandler}
          />
        </Box>
      )}
      <Box width={300} marginRight={3}>
        <TextField
          value={trailerSearchInput}
          onChange={searchChangeHandler}
          type='text'
          placeholder='Search trailers'
          icon='search'
        />
      </Box>
      <Box>
        <Switch
          label='Show Inactive & Unassigned'
          onChange={onInactiveToggleChange}
          checked={showInactiveAndUnassigned}
        />
      </Box>
    </Box>
  )
}

export default EquipmentListingFilter
